export enum TOURNAMENT_TYPE {
  SKA_MASTERS = 'skatmasters',
  SKA_MASTERS_GD = 'skatmasters_gd',
  SKA_TOURNAMENT = 'skat',
  SKA_TOURNAMENT_GD = 'skat_gd',
  ROM_MASTERS = 'rommemasters',
  ROM_MASTERS_GD = 'rommemasters_gd',
  ROM_TOURNAMENT = 'romme',
  ROM_TOURNAMENT_GD = 'romme_gd',
  BEL_TOURNAMENT = 'belote',
  BEL_TOURNAMENT_GD = 'belote_gd',
  NOT_MATCHING = 'not_matching',
}

export const TournamentTypeToName: { [tournamentType: string]: string } = {
  [TOURNAMENT_TYPE.SKA_MASTERS_GD]: 'skatmasters_gd',
  [TOURNAMENT_TYPE.SKA_MASTERS]: 'skatmasters',
  [TOURNAMENT_TYPE.SKA_TOURNAMENT]: 'skat',
  [TOURNAMENT_TYPE.SKA_TOURNAMENT_GD]: 'skat_gd',
  [TOURNAMENT_TYPE.ROM_MASTERS]: 'rommemasters',
  [TOURNAMENT_TYPE.ROM_MASTERS_GD]: 'rommemasters_gd',
  [TOURNAMENT_TYPE.ROM_TOURNAMENT]: 'romme',
  [TOURNAMENT_TYPE.ROM_TOURNAMENT_GD]: 'romme_gd',
  [TOURNAMENT_TYPE.BEL_TOURNAMENT]: 'belote',
  [TOURNAMENT_TYPE.BEL_TOURNAMENT_GD]: 'belote_gd',
}

export const NameToTournamentType: { [name: string]: TOURNAMENT_TYPE } = {
  skatmasters: TOURNAMENT_TYPE.SKA_MASTERS,
  skatmasters_gd: TOURNAMENT_TYPE.SKA_MASTERS_GD,
  skat: TOURNAMENT_TYPE.SKA_TOURNAMENT,
  skat_gd: TOURNAMENT_TYPE.SKA_TOURNAMENT_GD,
  rommemasters: TOURNAMENT_TYPE.ROM_MASTERS,
  rommemasters_gd: TOURNAMENT_TYPE.ROM_MASTERS_GD,
  romme: TOURNAMENT_TYPE.ROM_TOURNAMENT,
  romme_gd: TOURNAMENT_TYPE.ROM_TOURNAMENT_GD,
  belote: TOURNAMENT_TYPE.BEL_TOURNAMENT,
  belote_gd: TOURNAMENT_TYPE.BEL_TOURNAMENT_GD,
}
